<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Manufacturer" class="w-1/2">
      <input placeholder="Manufacturer" [ngModel]="itemDetail.product.productType.manufacturer.name" disabled pInputText />
    </uni-field>
    <uni-field label="Style" class="w-1/2">
      <input [ngModel]="itemDetail.product.productType.description" disabled pInputText />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Style" class="w-1/2">
      <input [ngModel]="itemDetail.product.productType.style" disabled pInputText />
    </uni-field>
    <uni-field label="Features" class="w-1/2">
      <input [ngModel]="itemDetail.product.featureChoicesExtract" disabled pInputText />
    </uni-field>
    <!-- <ng-container *ngFor="let pfc of this.itemDetail.product.productFeatureChoices; let i = index;">
      <uni-field label="Size" class="w-1/2">
        <input [ngModel]="pfc.featureChoice.choiceValue" disabled pInputText />
      </uni-field>
    </ng-container> -->
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Account (if account-owned)" class="w-1/2">
      <input [ngModel]="itemDetail.account?.accountName" disabled pInputText />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Damaged/Lost type" class="w-1/2">
      <p-dropdown
        [ngModel]="itemReplacementType"
        (ngModelChange)="onItemReplacementTypeChange($event)"
        [options]="itemReplacementTypes"
        optionLabel="name"
        appendTo="body"
      ></p-dropdown>
    </uni-field>
    <uni-field label="Status" class="w-1/2" [title]="itemReplacementStatus?.name">
      <p-dropdown
        [disabled]="itemReplacementType == null || itemReplacementType.isManufacturerRelated === 'N'"
        [(ngModel)]="itemReplacementStatus"
        [options]="itemReplacementStatuses"
        optionLabel="name"
        appendTo="body"
      ></p-dropdown>
    </uni-field>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="itemReplacementType == null" (click)="apply()" pButton type="button" class="p-button-raised">Apply</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
